/**
 * Shared Finnish translations for project-initialisation worker step labels.
 * The backend emits English step labels; the UI renders Finnish.
 */

export const STEP_LABEL_FI: Record<string, string> = {
  // Full-init step labels
  "Creating project": "Hankkeen luonti",
  "Setting up inspection platform": "Tarkastusalustan alustus",
  "Creating project roles": "Hankkeen roolien luonti",
  "Creating plots": "Projektien luonti",
  "Creating locations and targets": "Paikkojen ja kohteiden luonti",
  "Setting up inspection matrices": "Tarkastusmatriisien luonti",
  "Loading template data": "Tehtäväpohjien lataus",
  "Creating procurement packages": "Hankintapakettien luonti",
  "Creating sections and importing dates": "Osakohteiden luonti",
  "Creating inspection templates": "Tarkastuspohjien luonti",
  "Creating inspections": "Tarkastusten luonti",
  "Creating tasks": "Tehtävien luonti",
  // Mini-init step labels (8 steps)
  "Loading project context": "Hankkeen tietojen lataus",
  "Creating locations": "Sijaintien luonti",
  "Creating targets": "Tarkastuskohteiden luonti",
  "Resolving Congrid work sections": "Congrid-työvaiheiden haku",
  "Creating sections and section-locations": "Osakohteiden ja sijaintien luonti",
  "Creating inspection templates and inspections":
    "Tarkastuspohjien ja tarkastusten luonti",
  "Creating tasks and applying date updates":
    "Tehtävien luonti ja päivämäärien päivitys",
  // Terminal states — used by both flows
  Done: "Valmis",
  Error: "Virhe",
  Cancelled: "Peruutettu",
};

export function toFinnishLabel(label: string | undefined | null): string {
  if (!label) return "Käynnistetään...";
  return STEP_LABEL_FI[label] ?? label;
}
